module.exports = __webpack_public_path__ + "media/images/icons/v2/search-sm-0efa968b5b2c9e0390078ea5511e195d.svg";